import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold" }, "Accueil")
], -1)
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Importer les réservations")
const _hoisted_5 = {
  key: 0,
  class: "mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JbCard = _resolveComponent("JbCard")!
  const _component_JbButton = _resolveComponent("JbButton")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_JbCard, {
          title: "Réservations",
          icon: "user",
          number: _ctx.totalUpcomingReservations,
          footer: "A venir",
          class: "w-52"
        }, null, 8, ["number"]),
        _createVNode(_component_JbCard, {
          title: "Réservations",
          icon: "user",
          number: _ctx.totalReservations,
          footer: "Au total",
          class: "w-52"
        }, null, 8, ["number"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_JbCard, { title: 'Réservations' }, {
          default: _withCtx(() => [
            _createElementVNode("p", null, "Dernier import : " + _toDisplayString(_ctx.LastLodgifyImport), 1),
            _createVNode(_component_JbButton, { onClick: _ctx.lodgifyImportReservations }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.loadingReservations)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "spinner",
                    spin: ""
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}